module.exports = __webpack_public_path__ + "static/media/gift1.02f1cfd6.jpg";